


























































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class UpdatedReportFilter extends Vue {
  id = "updated-filter-popover";
  target = "updated-filter-target";
  filter = this.defaultFilter();
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    const filter = { ...this.filter };
    this.$store.state.gaps.filter.report.updated = filter;
    this.$emit('refresh');
    this.close();
  }

   setToday() {
    const today = new Date();
    this.filter.from = today;
    this.filter.to = today;
    this.search();
  }

  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { updated } = this.$store.state.gaps.filter.report;
    this.filter = JSON.parse(JSON.stringify(updated));
  }
}
